import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { IMultProConsultaRes } from "@pages/fabrica-credito/interfaces/IMultProConsultaRes";
import {
    IAnalistaRes,
    ICentralRes,
    IGetEntidadesRes,
    IGetGastosRes,
    IGetMonedasRes,
    IGetPromocionesRes,
    IGetTiendasRes,
    IMultpoAddUpdReq,
    IOficinasRes,
    IRegionalRes,
    ITelefoRes,
    IZonaCentralRes,
} from "@pages/fabrica-credito/interfaces/ISolicitudes";
import { 
    IInfoMultproEstatusRequest,
    IInfoMultproEstatusResponse,
    ISosprMotsegRequest,
    ISosprMotsegResponse,
    IMotivosConsultaTipoRequest,
    IMotivosConsultaTipoResponse,
    ISospaCambiaestmotRequest,
    ISospaCambiaestmotResponse,
    IVerificaAutomaticasRequest,
    IVerificaAutomaticasResponse
} from "@pages/fabrica-credito/interfaces/IEstatus";
import { ITerminaAutomaticasRequest, ITerminaAutomaticasResponse } from "@pages/fabrica-credito/abc-clientes-solicitudes/cliente/interfaces/IRutaCritica";
import { SimulaPromocion, IAmortizacionResponse } from "@pages/fabrica-credito/abc-clientes-solicitudes/cliente/btn-funciones/solicitudes/btn-funciones-solicitudes/solicitudes-amortizacion/solicitud-amort.component";
import { IValidaSolicitudReq } from "@pages/fabrica-credito/interfaces/IVerificaSolicitudes";
import { IVariablesScoring } from "@pages/fabrica-credito/abc-clientes-solicitudes/cliente/btn-funciones/solicitudes/btn-funciones-solicitudes/solicitudes-variables/solicitud-var.component";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { ICancelaAutorizacionRequest, ICancelaAutorizacionResponse } from "@pages/fabrica-credito/interfaces/ICancelacion";
import { ICampClteListRequest, ICampClteListResponse, INvoscampListRequest, INvoscampListResponse, ICmsprOpcnvosRequest, ICmsprOpcnvosResponse, ICampClteAddUpdRequest, ICampClteAddUpdResponse, ICampClteListClientRequest, ICampClteListClientResponse, ICampClteDeleteRequest, ICampClteDeleteResponse } from "@pages/fabrica-credito/interfaces/ICustomizable";
import { 
    IGetTelefonosRequest, 
    IGetTelefonosResponse,
    IGetTelefonoXNumeroRequest,
    IGetTelefonoXNumeroResponse,
    IGetTipoTelefonoResponse,
    ICreateTelefonoRequest,
    ICreateTelefonoResponse,
    IDeleteTelefonoRequest,
    IDeleteTelefonoResponse,
    IEditTelefonoRequest,
    IEditTelefonoResponse
} from '@pages/fabrica-credito/interfaces/ITelefonos';
import { IGarantiasListRequest, IGarantiasListResponse, IArticulosListRequest, IArticulosListResponse, IGarantiasAddRequest, IGarantiasAddResponse, IGarantiasListClientRequest, IGarantiasListClientResponse, IGarantiasUpdRequest, IGarantiasUpdResponse, IGarantiasDeleteRequest, IGarantiasDeleteResponse, IGarantiasListInvergranResponse } from "@pages/fabrica-credito/interfaces/IGarantias";
import { IGastosRequest, IGastosResponse } from '../interfaces/IGastos';

export interface IMultproConsultaClientReq {
    sUsuario: string;
    iAccion: number;
    sNumSol: string;
    smul_fechasol?: string;
    smul_promocion?: string;
    dmul_monto?: number;
    dmul_enganche?: number;
    smul_empresa?: string;
    smul_sucursal?: string;
    smul_vendedor?: string;
    imul_plazo?: number;
    dmul_tasa?: number;
    smul_moneda?: string;
    smul_analista?: string;
    smul_Documento?: string;
    smul_Tipo?: string;
    smul_Quien?: string;
    imul_QuienOdbc?: number;
    smul_IdCliente?: string;
    smul_destino?: string;
    smul_zona?: string;
    smul_zonacd?: string;
    smul_telemkt?: string;
    smul_clasifica?: string;
    smul_comentario?: string;
    sCentral?: string;
    sZonCent?: string;
    imul_mulodbc?: number;
}

export interface IMultproConsultaClientData {
    control: number;
    ingresada: string;
    producto: string;
    tipo: string;
    pop: number;
    analista: string;
    fecha_Estatus: string;
    hora_Estatus: string;
    estatus: string;
    empresa: string;
    sucursal: string;
    linea: number;
    motivo: string;
    descripcion: string;
    destino: string;
    enganche: number;
    descripcionProm: string;
    nombreEmp: string;
    sucursalEmp: string;
    plazo: number;
    tasa: number;
    numerodedocumento: string;
    vendedor: string;
    desvend: string;
}

export interface IMultproConsultaClientResponse {
    success: boolean;
    data: IMultproConsultaClientData[];
}

export interface IComentarioRequest {
    sUsuario: string;
    iAccion: number;
    sNumClte: string;
    imulodbc: number;
    iOdbc: number;
    sComent: string;
}

export interface INumRefAutomaticoRequest {
    sTpoProd: string;
}

export interface INumRefAutomaticoResponse {
    success: boolean;
    data: {
        sNumDoc: string;
    }[];
}

export interface ISeparaPipesResponse {
    success: boolean;
    data: Array<{
        opciones: string;
    }>;
}

@Injectable({
    providedIn: "root",
})
export class SolicitudesService {
    constructor(private http: HttpClient) {}

    multproConsultaClient(request: IMultproConsultaClientReq): Observable<IMultproConsultaClientResponse> {
        return this.http.post<IMultproConsultaClientResponse>(
            environment.apiNewBackBaseUrl + "Solicitudes/MultproConsultaClient",
            request
        );
    }

    multproConsulta(request: IMultproConsultaClientReq) {
        return this.http.post<IMultProConsultaRes>(environment.apiNewBackBaseUrl + "Solicitudes/MultproConsulta", request);
    }

    multpoAddUpd(request: IMultpoAddUpdReq) {
        return this.http.post<any>(environment.apiNewBackBaseUrl + "Solicitudes/MultproAddUpd", request);
    }

    multproDelete(request: IMultpoAddUpdReq) {
        return this.http.post<any>(environment.apiNewBackBaseUrl + "Solicitudes/MultproDelete", request);
    }

    validaSolicitud(request: IValidaSolicitudReq) {
        return this.http.post<any>(environment.apiNewBackBaseUrl + "VerificaSolicitudes/ValidaSolicitud", request);
    }

    verificaAutomaticas(request: IVerificaAutomaticasRequest): Observable<IVerificaAutomaticasResponse> {
        return this.http.post<IVerificaAutomaticasResponse>(
            environment.apiNewBackBaseUrl + "VerificaSolicitudes/VerificaAutomaticas",
            request
        );
    }

    terminaAutomaticas(request: ITerminaAutomaticasRequest): Observable<ITerminaAutomaticasResponse> {
        return this.http.post<ITerminaAutomaticasResponse>(
            environment.apiNewBackBaseUrl + "RutaCritica/TerminaAutomaticas",
            request
        );
    }

    // Servicios de Amortizacion
    AmortValorSimula(request: any): Observable<any> {
        return this.http.post<any>(environment.apiBaseUrl + "api/RenegociacionCreditos/AmortizacionSimulaPromocion", request);
    }

    AmortizacionSimulaPromocion(request: SimulaPromocion): Observable<any> {
        return this.http.post<IAmortizacionResponse[]>(environment.apiBaseUrl + "api/RenegociacionCreditos/AmortizacionSimulaPromocion", request);
    }

    AmortizacionSimulaEfectivo(request: any): Observable<any> {
        return this.http.post<any>(environment.apiBaseUrl + "api/RenegociacionCreditos/AmortizacionSimulaEfectivo", request);
    }

    SimulaEfectivo(request: any): Observable<any> {
        return this.http.post<any>(environment.apiNewBackBaseUrl + "Solicitudes/SimulaEfectivo", request);
    }

    AmortizacionSimulaComision(request: any): Observable<any> {
        return this.http.post<any>(environment.apiBaseUrl + "api/RenegociacionCreditos/AmortizacionSimulaComision", request);
    }

    // Servicios de Variables
    Varscoring(request: IVariablesScoring){
        return this.http.post<any>(environment.apiNewBackBaseUrl + "Varscoring/Varscoring", request);
    }

    VarscoringDetalle(request: IVariablesScoring){
        return this.http.post<any>(environment.apiNewBackBaseUrl + "Varscoring/VarscoringDetalle", request);
    }

    getLineas() {
        return this.http.get<IGetGastosRes>(environment.apiBaseUrl + "api/Gastos");
    }

    getEntidades() {
        return this.http.get<IGetEntidadesRes[]>(environment.apiBaseUrl + "api/GtEmpresas/GetEmpresas");
    }

    getTiendas(entidad: string) {
        return this.http.get<IGetTiendasRes>(environment.apiBaseUrl + "api/parimetria/CampoTablaWhere/sucursales/" + entidad);
    }

    getMonedas() {
        return this.http.get<IGetMonedasRes>(environment.apiBaseUrl + "api/parimetria/CampoTablaWhere/monedas");
    }

    getPromociones() {
        return this.http.get<IGetPromocionesRes[]>(environment.apiBaseUrl + "api/promociones");
    }

    getRegionales() {
        return this.http.get<IRegionalRes[]>(environment.apiBaseUrl + "api/OpcionesSolicitud/Zonas?limit=99");
    }

    getOficinas(regional: string) {
        return this.http.get<IOficinasRes[]>(environment.apiBaseUrl + "api/OpcionesSolicitud/ZonasCiudades?zona=" + regional);
    }

    getAsesores() {
        return this.http.get<any>(environment.apiBaseUrl + "api/OpcionesSolicitud/Vendedor");
    }

    getAnalistas() {
        return this.http.get<IAnalistaRes[]>(environment.apiBaseUrl + "api/OpcionesSolicitud/Analista");
    }

    getAsesores2() {
        return this.http.get<ITelefoRes[]>(environment.apiBaseUrl + "api/OpcionesSolicitud/Telefo");
    }

    getCentrales() {
        return this.http.get<ICentralRes[]>(environment.apiBaseUrl + "api/OpcionesSolicitud/Central?limit=99");
    }

    getZonas(central: string) {
        return this.http.get<IZonaCentralRes[]>(environment.apiBaseUrl + "api/OpcionesSolicitud/ZonaCentral?central=" + central);
    }

    // Servicios de Comentarios
    comentarioConsulta(request: IComentarioRequest): Observable<any> {
        return this.http.post<any>(
            environment.apiNewBackBaseUrl + "Comentarios/ComentarioConsultaClient",
            request
        );
    }

    comentarioAdd(request: IComentarioRequest): Observable<any> {
        return this.http.post<any>(
            environment.apiNewBackBaseUrl + "Comentarios/ComentarioAdd",
            request
        );
    }

    comentarioConsultaGeneral(request: IComentarioRequest): Observable<any> {
        return this.http.post<any>(
            environment.apiNewBackBaseUrl + "Comentarios/ComentarioConsulta",
            request
        );
    }

    comentarioUpdate(request: IComentarioRequest): Observable<any> {
        return this.http.post<any>(
            environment.apiNewBackBaseUrl + "Comentarios/ComentarioUpd",
            request
        );
    }

    comentarioDelete(request: IComentarioRequest): Observable<any> {
        return this.http.post<any>(
            environment.apiNewBackBaseUrl + "Comentarios/ComentarioDelete",
            request
        );
    }

    getInfoMultproEstatus(request: IInfoMultproEstatusRequest): Observable<IInfoMultproEstatusResponse> {
        return this.http.post<IInfoMultproEstatusResponse>(
            environment.apiNewBackBaseUrl + "Estatus/InfomultproEstatus",
            request
        );
    }

    getSosprMotseg(request: ISosprMotsegRequest): Observable<ISosprMotsegResponse> {
        return this.http.post<ISosprMotsegResponse>(
            environment.apiNewBackBaseUrl + "Estatus/sospr_motseg",
            request
        );
    }

    getMotivosConsultaTipo(request: IMotivosConsultaTipoRequest): Observable<IMotivosConsultaTipoResponse> {
        return this.http.post<IMotivosConsultaTipoResponse>(
            environment.apiNewBackBaseUrl + "Estatus/MotivosConsultaTipo",
            request
        );
    }

    setSospaCambiaestmot(request: ISospaCambiaestmotRequest): Observable<ISospaCambiaestmotResponse> {
        return this.http.post<ISospaCambiaestmotResponse>(
            environment.apiNewBackBaseUrl + "Estatus/sospa_cambiaestmot",
            request
        );
    }

    cancelaAutorizacion(request: ICancelaAutorizacionRequest): Observable<ICancelaAutorizacionResponse> {
        return this.http.post<ICancelaAutorizacionResponse>(
            environment.apiNewBackBaseUrl + "CancelaAutorizacion/CancelaAutorizacion",
            request
        );
    }

    getCampClteList(request: ICampClteListRequest): Observable<ICampClteListResponse> {
        return this.http.post<ICampClteListResponse>(`${environment.apiNewBackBaseUrl}Customizable/CampClteList`, request);
    }

    getNvoscampList(request: INvoscampListRequest): Observable<INvoscampListResponse> {
        return this.http.post<INvoscampListResponse>(`${environment.apiNewBackBaseUrl}Customizable/NvoscampList`, request);
    }

    getCmsprOpcnvos(request: ICmsprOpcnvosRequest): Observable<ICmsprOpcnvosResponse> {
        return this.http.post<ICmsprOpcnvosResponse>(`${environment.apiNewBackBaseUrl}Customizable/Cmspr_opcnvos`, request);
    }

    campClteAddUpd(request: ICampClteAddUpdRequest): Observable<ICampClteAddUpdResponse> {
        return this.http.post<ICampClteAddUpdResponse>(`${environment.apiNewBackBaseUrl}Customizable/CampClteAddUpd`, request);
    }

    campClteDelete(request: ICampClteDeleteRequest): Observable<ICampClteDeleteResponse> {
        return this.http.post<ICampClteDeleteResponse>(`${environment.apiNewBackBaseUrl}Customizable/CampClteDelete`, request);
    }

    getCampClteListClient(request: ICampClteListClientRequest): Observable<ICampClteListClientResponse> {
        return this.http.post<ICampClteListClientResponse>(`${environment.apiNewBackBaseUrl}Customizable/CampClteListClient`, request);
    }

    // Servicios de Teléfonos
    getTelefonos(request: IGetTelefonosRequest): Observable<IGetTelefonosResponse> {
        return this.http.post<IGetTelefonosResponse>(
            `${environment.apiNewBackBaseUrl}Telefono/GetTelefonos`,
            request
        );
    }

    getTelefonoXNumero(request: IGetTelefonoXNumeroRequest): Observable<IGetTelefonoXNumeroResponse> {
        return this.http.post<IGetTelefonoXNumeroResponse>(
            `${environment.apiNewBackBaseUrl}Telefono/GetTelefonoXNumero`,
            request
        );
    }

    getTipoTelefono(): Observable<IGetTipoTelefonoResponse> {
        return this.http.get<IGetTipoTelefonoResponse>(
            `${environment.apiNewBackBaseUrl}OpcionTelefono/GetTipoTelefono`
        );
    }

    createTelefono(request: ICreateTelefonoRequest): Observable<ICreateTelefonoResponse> {
        return this.http.post<ICreateTelefonoResponse>(
            `${environment.apiNewBackBaseUrl}Telefono/CreateTelefono`,
            request
        );
    }

    deleteTelefono(request: IDeleteTelefonoRequest): Observable<IDeleteTelefonoResponse> {
        return this.http.post<IDeleteTelefonoResponse>(
            `${environment.apiNewBackBaseUrl}Telefono/DeleteTelefono`,
            request
        );
    }

    editTelefono(request: IEditTelefonoRequest): Observable<IEditTelefonoResponse> {
        return this.http.post<IEditTelefonoResponse>(
            `${environment.apiNewBackBaseUrl}Telefono/EditTelefono`,
            request
        );
    }

    // Servicios de Garantías
    getGarantiasList(request: IGarantiasListRequest): Observable<IGarantiasListResponse> {
        return this.http.post<IGarantiasListResponse>(
            `${environment.apiNewBackBaseUrl}Garantias/GarantiasList`,
            request
        );
    }

    garantiasAdd(request: IGarantiasAddRequest): Observable<IGarantiasAddResponse> {
        return this.http.post<IGarantiasAddResponse>(
            `${environment.apiNewBackBaseUrl}Garantias/GarantiasAdd`,
            request
        );
    }

    garantiasUpd(request: IGarantiasUpdRequest): Observable<IGarantiasUpdResponse> {
        return this.http.post<IGarantiasUpdResponse>(
            `${environment.apiNewBackBaseUrl}Garantias/GarantiasUpd`,
            request
        );
    }

    garantiasDelete(request: IGarantiasDeleteRequest): Observable<IGarantiasDeleteResponse> {
        return this.http.post<IGarantiasDeleteResponse>(
            `${environment.apiNewBackBaseUrl}Garantias/GarantiasDelete`,
            request
        );
    }

    getGarantiasListClient(request: IGarantiasListClientRequest): Observable<IGarantiasListClientResponse> {
        return this.http.post<IGarantiasListClientResponse>(
            `${environment.apiNewBackBaseUrl}Garantias/GarantiasListClient`,
            request
        );
    }

    getArticulosList(request: IArticulosListRequest): Observable<IArticulosListResponse> {
        return this.http.post<IArticulosListResponse>(
            `${environment.apiNewBackBaseUrl}Garantias/ArticulosList`,
            request
        );
    }

    getGarantiasListInvergran(): Observable<IGarantiasListInvergranResponse> {
        return this.http.post<IGarantiasListInvergranResponse>(
            `${environment.apiNewBackBaseUrl}Garantias/GetGarantiasListInvergran`,
            {}
        );
    }

    getNumRefAutomatico(payload: INumRefAutomaticoRequest): Observable<INumRefAutomaticoResponse> {
        return this.http.post<INumRefAutomaticoResponse>(
            `${environment.apiNewBackBaseUrl}Solicitudes/Num_Ref_Automatico`,
            payload
        );
    }

    getGastos(request: IGastosRequest): Observable<IGastosResponse> {
        return this.http.post<IGastosResponse>(`${environment.apiNewBackBaseUrl}Gastos/GetGastos`, request);
    }

    separaPipes(request: { sCadena: string }): Observable<ISeparaPipesResponse> {
        return this.http.post<ISeparaPipesResponse>(`${environment.apiNewBackBaseUrl}Solicitudes/SeparaPipes`, request);
    }
}

